import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Dashboard from "./components/Pages/Dashboard";
import DailyRates from "./components/Pages/DailyRates";
import AddDailyRates from "./components/Pages/AddDailyRates";
import UpdateDailyRates from "./components/Pages/UpdateDailyRates";
import User from "./components/Pages/User";
import Product from "./components/Pages/Product";
import Customer from "./components/Pages/Customer";
import Supplier from "./components/Pages/Supplier";
import Purchase from "./components/Pages/Purchase";
import AddPurchase from "./components/Pages/AddPurchase";
import Retailer from "./components/Pages/Retailer";
import AddRetailer from "./components/Pages/AddRetailer";
import Order from "./components/Pages/Order";
import Sales from "./components/Pages/Sales";
import AddSales from "./components/Pages/AddSales";
import WhitePageBalance from "./components/Pages/WhitePageBalance";
import BluePageBalance from "./components/Pages/BluePageBalance";
import ChitCreation from "./components/Pages/ChitCreation";
import ChitList from "./components/Pages/ChitList";
import Loan from "./components/Pages/Loan";
import Stock from "./components/Pages/Stock";
import AddStock from "./components/Pages/AddStock";
import Expense from "./components/Pages/Expense";
import SalesVsExpense from "./components/Pages/SalesVsExpense";
import ChitListPaymentHistory from "./components/Pages/ChitListPaymentHistory";
import Login from "./components/Login/Login";
import { ToastProvider } from "./components/Toast/ToastContext";
import ProductItem from "./components/Pages/ProductItem";
import ExpenseType from "./components/Pages/ExpenseType";
import SalesExpense from "./components/Pages/SalesExpense";
import SalesBill from "./components/Pages/SalesBill";
import LoanpaymentHistroy from "./components/Pages/LoanpaymentHistroy";
import UpdateSales from "./components/Pages/UpdateSales";
import OrderSmallBill from "./components/Pages/OrderSmallBill";
import UpdatePurchase from "./components/Pages/UpdatePurchase";
import AddOrder from "./components/Pages/AddOrder";
import UpdateOrder from "./components/Pages/UpdateOrder";
import AddLoan from "./components/Pages/AddLoan";
import UpdateLoan from "./components/Pages/UpdateLoan";
import Bill from "./components/Pages/Bill";
import ProtectedRoute from "./components/Pages/Helper";
import Report from "./components/Pages/Report";
import Example from "./components/Pages/Example";
import UpdateRetailer from "./components/Pages/UpdateRetailer";
import Personal_stock from "./components/Pages/Personal_Stock";
import AddPersonalStock from "./components/Pages/AddPersonalStock";
import Viewstock from "./components/Pages/Viewstock";
import DailyRatesPopup from "./components/Pages/DailyRatesPopup";
import { RatesProvider } from "./components/Pages/RatesContext";
import PersonalviewStock from "./components/Pages/PersonalviewStock";
import OrderBigBill from "./components/Pages/OrderBigBill";
import RetailerSmallBill from "./components/Pages/RetailerSmallBill";
import Purchasesmallbill from "./components/Pages/Purchasesmallbill";
import ChitSmallbill from "./components/Pages/ChitSmallbill";
import Loanbill from "./components/Pages/Loanbill";
import EditStock from "./components/Pages/EditStock";
import Personal_EditStock from "./components/Pages/Personal_EditStock";
import ClosedLoans from "./components/Pages/ClosedLoans";

// Placeholder component for pages that haven't been created yet
const PlaceholderPage = ({ title }) => (
  <div className="page-container">
    <h1>{title}</h1>
    <p>This page is under construction.</p>
  </div>
);

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("dashboard");

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <RatesProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            {/* Login route - standalone without any layout */}
            <Route path="/" element={<Login />} />
            <Route path="/dailyrates-popup" element={<DailyRatesPopup />} />

            {/* <Route path="/sales-bill/:sales_no" element={<SalesBill />} /> */}

            <Route path="/sales-bill/:sales_no" element={<SalesBill />} />
            <Route path="/bill/:sales_no" element={<Bill />} />

            <Route path="/loan/:loan_id" element={<Loanbill />} />
            <Route
              path="/order-small-bill/:order_no"
              element={<OrderSmallBill />}
            />
            <Route
              path="/purchase-bill/:purchase_id"
              element={<Purchasesmallbill />}
            />
            <Route path="/chit-bill/:id" element={<ChitSmallbill />} />
            <Route
              path="/order-big-bill/:order_no"
              element={<OrderBigBill />}
            />
            <Route
              path="/retailer-bill/:retailer_id"
              element={<RetailerSmallBill />}
            />

            {/* All other routes - wrapped with common layout */}
            <Route
              path="*"
              element={
                <div className="App">
                  <Sidebar
                    collapsed={sidebarCollapsed}
                    toggleSidebar={toggleSidebar}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                  />
                  <div
                    className={`content-wrapper ${
                      sidebarCollapsed ? "sidebar-collapsed" : ""
                    }`}
                  >
                    <Navbar collapsed={sidebarCollapsed} />
                    <main className="main-content">
                      <Routes>
                        <Route
                          path="/dashboard"
                          element={
                            <ProtectedRoute>
                              <Dashboard />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/daily-rates"
                          element={
                            <ProtectedRoute>
                              <DailyRates />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/example"
                          element={
                            <ProtectedRoute>
                              <Example />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-daily-rates"
                          element={
                            <ProtectedRoute>
                              <AddDailyRates />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/update-daily-rates/:id"
                          element={
                            <ProtectedRoute>
                              <UpdateDailyRates />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/user"
                          element={
                            <ProtectedRoute>
                              <User />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/products"
                          element={
                            <ProtectedRoute>
                              <Product />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/product-item"
                          element={
                            <ProtectedRoute>
                              <ProductItem />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/customers"
                          element={
                            <ProtectedRoute>
                              <Customer />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/suppliers"
                          element={
                            <ProtectedRoute>
                              <Supplier />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/purchases"
                          element={
                            <ProtectedRoute>
                              <Purchase />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-purchase"
                          element={
                            <ProtectedRoute>
                              <AddPurchase toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/update-purchase/:id"
                          element={
                            <ProtectedRoute>
                              <UpdatePurchase toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/retailers/update-retailer/:id"
                          element={
                            <ProtectedRoute>
                              <UpdateRetailer toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/retailers"
                          element={
                            <ProtectedRoute>
                              <Retailer />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-retailer"
                          element={
                            <ProtectedRoute>
                              <AddRetailer toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/orders"
                          element={
                            <ProtectedRoute>
                              <Order />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-order"
                          element={
                            <ProtectedRoute>
                              <AddOrder toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/update-order/:id"
                          element={
                            <ProtectedRoute>
                              <UpdateOrder toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/sales"
                          element={
                            <ProtectedRoute>
                              <Sales />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/report"
                          element={
                            <ProtectedRoute>
                              <Report />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-sales"
                          element={
                            <ProtectedRoute>
                              <AddSales toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/update-sales/:id"
                          element={
                            <ProtectedRoute>
                              <UpdateSales toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/balance/white-page-balance"
                          element={
                            <ProtectedRoute>
                              <WhitePageBalance />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/balance/blue-page-balance"
                          element={
                            <ProtectedRoute>
                              <BluePageBalance />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/chit/chit-creation"
                          element={
                            <ProtectedRoute>
                              <ChitCreation />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/chit/chit-list"
                          element={
                            <ProtectedRoute>
                              <ChitList />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/chit/chit-list/payment-history/:customer_id"
                          element={
                            <ProtectedRoute>
                              <ChitListPaymentHistory />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/loan"
                          element={
                            <ProtectedRoute>
                              <Loan />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-loan"
                          element={
                            <ProtectedRoute>
                              <AddLoan toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/update-loan/:id"
                          element={
                            <ProtectedRoute>
                              <UpdateLoan toggleSidebar={toggleSidebar} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/loan-history/:id"
                          element={
                            <ProtectedRoute>
                              <LoanpaymentHistroy />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/stocks"
                          element={
                            <ProtectedRoute>
                              <Stock />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/closed-loans"
                          element={
                            <ProtectedRoute>
                              <ClosedLoans />
                            </ProtectedRoute>
                          }
                        />
                        
                        <Route
                          path="/Viewstock/:stock_ids"
                          element={
                            <ProtectedRoute>
                              <Viewstock />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-stock"
                          element={
                            <ProtectedRoute>
                              <AddStock />
                            </ProtectedRoute>
                          }
                        />


                         <Route
                          path="/Edit-stock/:stock_ids"
                          element={
                            <ProtectedRoute>
                              <EditStock />
                            </ProtectedRoute>
                          }
                        />



                          <Route
                          path="/Edit-personalstock/:stock_ids"
                          element={
                            <ProtectedRoute>
                              <Personal_EditStock />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/expense"
                          element={
                            <ProtectedRoute>
                              <Expense />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/expense-item"
                          element={
                            <ProtectedRoute>
                              <ExpenseType />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/personal-stock"
                          element={
                            <ProtectedRoute>
                              <Personal_stock />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-personal-stock"
                          element={
                            <ProtectedRoute>
                              <AddPersonalStock />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/PersonalviewStock/:stock_ids"
                          element={
                            <ProtectedRoute>
                              <PersonalviewStock />
                            </ProtectedRoute>
                          }
                        />

                        <Route
                          path="/sales-vs-expense"
                          element={
                            <ProtectedRoute>
                              <SalesExpense />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/add-sales-vs-expense/:date"
                          element={
                            <ProtectedRoute>
                              <SalesVsExpense />
                            </ProtectedRoute>
                          }
                        />
                      </Routes>
                    </main>
                    <Footer />
                  </div>
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </RatesProvider>
  );
}

export default App;
